module.exports = __webpack_public_path__ + "static/img/profile.f956d0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/profile.svg
// module id = 8zhA
// module chunks = 2